import React from "react";
import { useSeo } from "@/lib/useSeo";
import { KineticHeading, FadeIn } from "@/components/motion/Reveal";
import { Button, Eyebrow } from "@/components/ui-kit";
import { HOME_HERO } from "@/data/site";
import { SEO } from "@/data/seo";
import HomeSections from "@/pages/HomeBelowFold";

// Typographic hero — no stock photography. Dark field, teal accent, kinetic headline.
function Hero() {
  return (
    <section className="relative flex min-h-[100svh] items-end overflow-hidden bg-charcoal" data-testid="home-hero">
      <div className="pointer-events-none absolute inset-0" aria-hidden="true">
        <div className="absolute -right-32 top-24 h-[42rem] w-[42rem] rounded-full border border-paper/5" />
        <div className="absolute -right-10 top-48 h-[28rem] w-[28rem] rounded-full border border-teal/15" />
        <div className="absolute left-6 top-0 h-full w-px bg-paper/5 lg:left-10" />
      </div>

      <div className="relative mx-auto w-full max-w-8xl px-6 pb-20 pt-40 lg:px-10 lg:pb-24 lg:pt-48">
        <FadeIn delay={0.05}>
          <Eyebrow dark plain>{HOME_HERO.eyebrow}</Eyebrow>
        </FadeIn>

        <h1 className="mt-7 max-w-5xl font-serif text-[2.1rem] font-normal leading-[1.15] tracking-tightish text-paper sm:text-[2.9rem] sm:leading-[1.08] lg:text-[3.9rem] lg:leading-[1.05]">
          <KineticHeading
           
            delay={0.12}
            stagger={0.08}
            lines={["Critical initiatives need senior", "leadership—not always another", "full-time hire."]}
          />
        </h1>

        <FadeIn delay={0.25}>
          <p className="mt-8 max-w-2xl text-base leading-[1.75] text-paper/80 sm:text-lg lg:mt-10" data-testid="hero-body">
            {HOME_HERO.body}
          </p>
          <div className="mt-9 flex flex-wrap items-center gap-4 lg:mt-11">
            <Button to="/contact" track="primary" data-testid="hero-cta-primary">{HOME_HERO.primary}</Button>
            <Button to="/services" variant="dark" track="secondary" data-testid="hero-cta-secondary">
              {HOME_HERO.secondary}
            </Button>
          </div>
        </FadeIn>

        <FadeIn delay={0.7} className="mt-16 hidden border-t border-paper/10 pt-6 lg:block">
          <p className="text-xs uppercase tracking-mega text-paper/60">
            Regulated · Growth-stage · PE-backed organizations — Dallas–Fort Worth, serving nationally
          </p>
        </FadeIn>
      </div>
    </section>
  );
}

export default function Home() {
  useSeo({ ...SEO["/"], path: "/" });
  return (
    <>
      <Hero />
      <HomeSections />
    </>
  );
}
